import { Col, Collapse, Row, Tabs } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
interface CollapseProps {
  className?: string;
  CollapseArray?: any[];
  tabsData: any[];
  data: any;

}
const CollapseContent = ({ data, tabsData, ...props }: CollapseProps) => {
  const { t } = useTranslation();
  return (
    <Tabs
      tabBarStyle={{ display: "flex", overflowX: "auto" }}
      className={`takaful--content-profile-tab ${props.className || ""}`}
      defaultActiveKey="1"
      items={tabsData.map(({ label, array }, i) => {
        const id = String(i + 1);
        return {
          key: id,
          label: (
            <Row style={{ width: "100%" }}>
              <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <div className="tab-label">
                  <span className="tab-label-text">{label}</span>
                  <div className="tab-number">
                    <span>{array?.length || 0}</span>
                  </div>
                </div>
              </Col>
            </Row>
          ),
          children: (
            <div className="takaful--collapse-profile-container">
              <Collapse
                {...props}
                className={`takaful--collapse-profile`}
                accordion
                defaultActiveKey={["0"]}
              >
                {array?.map((element: any, index: any) => (
                  <Collapse.Panel
                    className="takaful--header-profile-Panel"
                    showArrow={false}
                    header={
                      <div className="takaful--header-profile-container">
                        <Row
                          className="takaful--content-profile-box1"
                          style={{ marginBottom: "0" }}
                        >
                          <Col
                            xxl={5}
                            xl={5}
                            lg={5}
                            md={5}
                            sm={12}
                            xs={12}
                            className="takaful--content-profile-col"
                          >
                            <p>الإسم</p>
                          </Col>
                          <Col
                            xxl={7}
                            xl={7}
                            lg={7}
                            md={7}
                            sm={12}
                            xs={12}
                            className="takaful--content-profile-col"
                          >
                            <span>
                              {element?.firstname + " " + element?.father_name}
                            </span>
                          </Col>

                          <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

                          <Col
                            xxl={5}
                            xl={5}
                            lg={5}
                            md={5}
                            sm={12}
                            xs={12}
                            className="takaful--col-content"
                          >
                            <p>العمر</p>
                          </Col>
                          <Col
                            xxl={6}
                            xl={6}
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            style={{ marginLeft: "-1.6rem" }}
                            className="takaful--col-content"
                          >
                            <span>{element?.age}</span>
                          </Col>
                        </Row>
                      </div>
                    }
                    key={index}
                  >
                    <Row
                      justify={"space-between"}
                      className={`takaful--content-profile-box1  ${
                        props.className ? props.className : ""
                      }`}
                    >
                      <Col
                        xxl={5}
                        xl={5}
                        lg={5}
                        md={5}
                        sm={12}
                        xs={12}
                        className="takaful--content-profile-col"
                      >
                        <p>رقم الأسرة</p>
                      </Col>
                      <Col
                        xxl={6}
                        xl={6}
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        className="takaful--content-profile-col"
                      >
                        <span>{element?.beneficiary_family_number}</span>
                      </Col>

                      <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

                      <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                        <p>مدفوع إلى</p>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                      <span className="takaful--content-services-request-span takaful--date-format">
                      {element?.sponsorship_paid_to}
                    </span>
                      </Col>
                    </Row>
                    <Row
                      justify={"space-between"}
                      className="takaful--content-profile-box1"
                    >
                      <Col
                        xxl={5}
                        xl={5}
                        lg={5}
                        md={5}
                        sm={12}
                        xs={12}
                        className="takaful--content-profile-col"
                      >
                        <p>الجنس</p>
                      </Col>
                      <Col
                        xxl={6}
                        xl={6}
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        className="takaful--content-profile-col"
                      >
                        <span>{t(`gender.${element?.gender}`)}</span>
                      </Col>

                      <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

                      <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}></Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}></Col>
                    </Row>
                    <Row
                      justify={"space-between"}
                      className="takaful--content-profile-box1"
                    >
                      <Col
                        xxl={5}
                        xl={5}
                        lg={5}
                        md={5}
                        sm={12}
                        xs={12}
                        className="takaful--content-profile-col"
                      >
                        <p>الحالة الصحيّة</p>
                      </Col>
                      <Col
                        xxl={6}
                        xl={6}
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        className="takaful--content-profile-col"
                      >
                        <span>{element?.health_state_id}</span>
                      </Col>

                      <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

                      <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                        <p>المستوى الدراسي</p>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <span>{element?.academic_level_id}</span>
                      </Col>
                    </Row>
                    <Row
                      justify={"space-between"}
                      className="takaful--content-profile-box1"
                    >
                      <Col
                        xxl={5}
                        xl={5}
                        lg={5}
                        md={5}
                        sm={12}
                        xs={12}
                        className="takaful--content-profile-col"
                      >
                        {element?.disease_type_ids &&
                          element.disease_type_ids.length > 0 && (
                            <p>الأمراض</p>
                          )}
                      </Col>
                      <Col
                        xxl={6}
                        xl={6}
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        className="takaful--content-profile-col"
                      >
                        <span>
                          {element?.disease_type_ids
                            ?.map((method: any) => method?.name)
                            .join(", ")}
                        </span>
                      </Col>

                      <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

                      <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                        <p>السنة الدراسية</p>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <span>{element?.academic_year_id}</span>
                      </Col>
                    </Row>
                  </Collapse.Panel>
                ))}
              </Collapse>
            </div>
          ),
        };
      })}
    />
  );
};

export default CollapseContent;
